// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shimmer {
  color: rgb(175, 175, 175);
  display: inline-block;
  mask: linear-gradient(-60deg, #000 40%, #0005, #000 60%) right/350% 100%;
  animation: shimmer 4.5s infinite;
  font-size: 50px;
  max-width: 400px;
  max-height: 350px;
}

@keyframes shimmer {
  100% {
    mask-position: left
  }
}

.fade-enter {
  opacity: 0;
  transform: translateX(100%);
}
.fade-enter-active {
  opacity: 1;
  transform: translateX(0);
  transition: opacity 500ms ease-in, transform 500ms ease-in;
}
.fade-exit {
  opacity: 1;
  transform: translateX(0);
}
.fade-exit-active {
  opacity: 0;
  transform: translateX(-100%);
  transition: opacity 500ms ease-in, transform 500ms ease-in;
}

/* Style for the speech bubble container */
.speech-bubble {
  position: relative;
  background: #ffffff;
  border: 2px solid #333;
  border-radius: 10px;
  padding: 20px;
  max-width: 400px;
  margin-left: 40px; /* Space to make room for the tail */
}

/* Tail of the bubble (white part) */
.speech-bubble:after {
  content: '';
  position: absolute;
  top: 20px; /* Adjust to position the tail vertically */
  left: -10px; /* Move it to the left edge */
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #ffffff; /* White tail to match bubble background */
}

/* Tail border to match the bubble's border */
.speech-bubble:before {
  content: '';
  position: absolute;
  top: 19px; /* Align with the tail slightly */
  left: -12px; /* Slightly more negative to overlap the tail */
  width: 0;
  height: 0;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-right: 12px solid #333; /* Border color to match the bubble */
}
`, "",{"version":3,"sources":["webpack://./src/css/shimmer.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,wEAAwE;EACxE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,0DAA0D;AAC5D;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,4BAA4B;EAC5B,0DAA0D;AAC5D;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,iBAAiB,EAAE,oCAAoC;AACzD;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS,EAAE,2CAA2C;EACtD,WAAW,EAAE,6BAA6B;EAC1C,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,qCAAqC;EACrC,gCAAgC,EAAE,0CAA0C;AAC9E;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS,EAAE,iCAAiC;EAC5C,WAAW,EAAE,+CAA+C;EAC5D,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,qCAAqC;EACrC,6BAA6B,EAAE,qCAAqC;AACtE","sourcesContent":[".shimmer {\n  color: rgb(175, 175, 175);\n  display: inline-block;\n  mask: linear-gradient(-60deg, #000 40%, #0005, #000 60%) right/350% 100%;\n  animation: shimmer 4.5s infinite;\n  font-size: 50px;\n  max-width: 400px;\n  max-height: 350px;\n}\n\n@keyframes shimmer {\n  100% {\n    mask-position: left\n  }\n}\n\n.fade-enter {\n  opacity: 0;\n  transform: translateX(100%);\n}\n.fade-enter-active {\n  opacity: 1;\n  transform: translateX(0);\n  transition: opacity 500ms ease-in, transform 500ms ease-in;\n}\n.fade-exit {\n  opacity: 1;\n  transform: translateX(0);\n}\n.fade-exit-active {\n  opacity: 0;\n  transform: translateX(-100%);\n  transition: opacity 500ms ease-in, transform 500ms ease-in;\n}\n\n/* Style for the speech bubble container */\n.speech-bubble {\n  position: relative;\n  background: #ffffff;\n  border: 2px solid #333;\n  border-radius: 10px;\n  padding: 20px;\n  max-width: 400px;\n  margin-left: 40px; /* Space to make room for the tail */\n}\n\n/* Tail of the bubble (white part) */\n.speech-bubble:after {\n  content: '';\n  position: absolute;\n  top: 20px; /* Adjust to position the tail vertically */\n  left: -10px; /* Move it to the left edge */\n  width: 0;\n  height: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  border-right: 10px solid #ffffff; /* White tail to match bubble background */\n}\n\n/* Tail border to match the bubble's border */\n.speech-bubble:before {\n  content: '';\n  position: absolute;\n  top: 19px; /* Align with the tail slightly */\n  left: -12px; /* Slightly more negative to overlap the tail */\n  width: 0;\n  height: 0;\n  border-top: 12px solid transparent;\n  border-bottom: 12px solid transparent;\n  border-right: 12px solid #333; /* Border color to match the bubble */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
